/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react'
import classnames from 'classnames';

import { colorNamesEnum, typographyEnum, colorClassNames, typography } from 'styles/styleUtility';

interface Props {
  size?: typographyEnum,
  colorName?: colorNamesEnum,
  className?: string,
  style?: any;
  withPadding?: boolean;
}
export const Text: FC<Props>  = (props) => {
  const { size, colorName, children, className, style, withPadding } = props;
  const colorClassName = colorName ? colorClassNames.font(colorName) : null;
  const sizeClassName = size ? typography.font(size) : null;
  const paddingClassName = withPadding ? 'util-frame-gutters' : '';
  return (
    <span className={classnames(sizeClassName, colorClassName, className, paddingClassName)} style={style}>
      {children}
    </span>
  );
}

export const Headline: FC<Props> = (props) => <Text {...props} size={typographyEnum.headline} />;
export const Subhead: FC<Props> = (props) => <Text {...props} size={typographyEnum.subhead} />;
export const Caption1: FC<Props> = (props) => <Text {...props} size={typographyEnum.caption1} />;
export const DefaultBody: FC<Props> = (props) => <Text {...props} size={typographyEnum.body} />;